/**
 * 클라이언트용 경량 비속어 목록
 * - 즉각적인 UX 피드백을 위해 가장 빈번하게 사용되는 비속어만 포함
 * - 전체 목록은 서버에서 처리 (word_list.json)
 * - ~80개 단어로 번들 사이즈 최소화
 */

export const PROFANITY_WORDS_CLIENT: string[] = [
    // 가장 흔한 욕설 (핵심 ~30개)
    "시발",
    "씨발",
    "씨팔",
    "시팔",
    "씨벌",
    "시벌",
    "씨빨",
    "씨불",
    "씨붕",
    "ㅅㅂ",
    "ㅆㅂ",
    "병신",
    "ㅂㅅ",
    "ㅄ",
    "새끼",
    "개새끼",
    "쌔끼",
    "썅",
    "지랄",
    "ㅈㄹ",
    "좆",
    "좃",
    "존나",
    "졸라",
    "느금마",
    "니애미",
    "니애비",
    "미친",
    "미친놈",
    "미친년",

    // 주요 파생어 (~20개)
    "개같은",
    "개년",
    "개놈",
    "개자식",
    "개지랄",
    "씹새끼",
    "씹년",
    "씹창",
    "씹팔",
    "십새끼",
    "십팔",
    "쌍년",
    "쌍놈",
    "염병",
    "엿먹어라",
    "꺼져",
    "닥쳐",
    "뒈져",
    "뒤질",
    "죽을래",

    // 성적 비속어 (~15개)
    "보지",
    "자지",
    "섹스",
    "야동",
    "강간",
    "창녀",
    "창년",
    "걸레",
    "씹",
    "좆같",
    "조까",
    "fuck",
    "shit",
    "bitch",
    "ass",

    // 초성/변형 (~15개)
    "ㅁㅊ",
    "ㅅㅍ",
    "ㅆㅍ",
    "ㅅㅐ",
    "ㅅㅣ발",
    "^ㅣ발",
    "시bal",
    "tlqkf",
    "sibal",
    "wtf",
    "18놈",
    "18새끼",
    "10새끼",
    "쉬발",
    "쒸팔"
];

/**
 * 클라이언트용 빠른 비속어 체크
 * - 정확도보다 속도 우선
 * - 서버에서 전체 필터링 수행
 */
export function quickProfanityCheck(text: string): boolean {
    if (!text) return false;

    const normalizedText = text.toLowerCase().replace(/\s+/g, "");

    for (const word of PROFANITY_WORDS_CLIENT) {
        const normalizedWord = word.toLowerCase().replace(/\s+/g, "");
        if (normalizedText.includes(normalizedWord)) {
            return true;
        }
    }

    return false;
}
